(() => {
  let lastScrollY = window.scrollY;

  const initInView = () => {
    const items = document.querySelectorAll('.js-inview-EachItem');

    if (!items.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const currentScrollY = window.scrollY;
        const scrollingDown = currentScrollY > lastScrollY;

        lastScrollY = currentScrollY;

        entries
          .filter(entry => entry.isIntersecting)
          .forEach((entry, index) => {
            const el = entry.target;

            // If scrolling up, show immediately without animation
            if (!scrollingDown) {
              el.style.opacity = '1';
              el.style.transform = 'translate3d(0, 0, 0)';
              observer.unobserve(el);
              return;
            }

            // Animate only when scrolling down
            setTimeout(() => {
              el.style.transition =
                'opacity 1.2s ease, transform 1.2s cubic-bezier(0.22, 1, 0.36, 1)';
              el.style.opacity = '1';
              el.style.transform = 'translate3d(0, 0, 0)';
            }, index * 200);

            observer.unobserve(el);
          });
      },
      {
        threshold: 0.15,
        rootMargin: '0px 0px -10% 0px',
      }
    );

    items.forEach((item) => {
      const rect = item.getBoundingClientRect();

      // Visible on initial load -> no animation
      // if (rect.top < window.innerHeight && rect.bottom > 0) {
      //   item.style.opacity = '1';
      //   item.style.transform = 'translate3d(0, 0, 0)';
      // } else {
        observer.observe(item);
      // }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInView);
  } else {
    initInView();
  }

  document.addEventListener('shopify:section:load', initInView);
})();